export default "__VITE_ASSET__BMvA7ept__"